import { render } from "./HistorialComandas.vue?vue&type=template&id=54f25801&scoped=true"
import script from "./HistorialComandas.vue?vue&type=script&lang=js"
export * from "./HistorialComandas.vue?vue&type=script&lang=js"

import "./HistorialComandas.vue?vue&type=style&index=0&id=54f25801&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f25801"]])

export default __exports__